import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

export const MainItemContent = styled(Vertical)`
  flex: 1;
  border-left: 1px solid var(--c-neutral-150);
  padding-left: var(--unit);
`;
